// Kido's public contact details, printed on invoices. Same values as
// kido-frontend's config/brand.js — keep the two in step.
export const BRAND = {
  name: "Kido",
  phone: "+8801577333327",
  email: "kido.com.bd@gmail.com",
  whatsapp: "8801577333327",
};
